import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import logo from "../../../assest/images/logo.png";

const LoadingSpinner = ({ text = "Keelis!" }) => {
  const [characters, setCharacters] = useState([]);

  useEffect(() => {
    setCharacters(text.split(""));
  }, [text]);

  return (
    <div className="h-screen flex items-center justify-center bg-white">
      <h1 className="font-mono font-bold text-[clamp(3rem,13vw,10rem)] uppercase flex relative overflow-hidden items-center">
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ width: "70px", height: "50px" }}>
            <motion.img
              src={logo}
              alt="Logo"
              style={{ width: "100%" }}
              // className="h-10 w-10 mr-4"
              // initial={{ y: '-100%', opacity: 0 }}
              animate={{
                // y: ['-100%', '0%', '0%', '100%'],
                opacity: [0, 1, 1, 0],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "linear",
                delay: 0,
              }}
            />
          </div>
          <div style={{ paddingleft: "2%" }}>
            {characters.map((char, index) => (
              <motion.span
                key={index}
                initial={{ y: "-100%", opacity: 0 }}
                animate={{
                  y: ["-100%", "0%", "0%", "100%"],
                  opacity: [0, 1, 1, 0],
                  color: "#3f51b5d4",
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "linear",
                  delay: index * 0.2,
                }}
                style={{ marginleft: "10px" }}
                className="inline-block"
              >
                {char}
              </motion.span>
            ))}
          </div>
        </div>
      </h1>
    </div>
  );
};

export default LoadingSpinner;
